
import ViewModel from '@/models/ViewModel'
import { Component, Ref, Vue } from 'vue-property-decorator'
import Widget from '@/components/Widget/Widget.vue'
import FormInput from '@/components/FormInput/FormInput.vue'
import FooterNav from '@/components/FooterNav/FooterNav.vue'
import AudienceSegmentsModule from '@/models/AudienceSegments'
import CompanyPicker from '@/components/CompanyPicker/CompanyPicker.vue'

@Component({
  components: {
    Widget,
    FormInput,
    FooterNav,
    CompanyPicker,
  },
})
export default class AudienceSegment extends ViewModel {
  @Ref() readonly validator!: any

  public busy: boolean = true

  public audience_segment: AudienceSegmentsModule = new AudienceSegmentsModule()

  public get isEditing(): boolean {
    return this.$route.params.id !== undefined
  }

  public mounted() {
    if (this.isEditing) {
      this.busy = true
      this.loading = true
      AudienceSegmentsModule.find(this.$route.params.id)
        .then(response => {
          this.audience_segment = response
          this.busy = false
          this.loading = false
        })
        .catch(error => {
          console.error('Error fetching audience segment:', error)
        })
    } else {
      this.busy = false
      this.loading = false
    }
  }

  public save() {
    this.loading = true
    this.audience_segment.save().then(response => {
      if (response.status === 200) {
        this.$router.push({ name: 'audience-segments' })
      } else {
        this.loading = false
      }
    })
  }
}
